var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62124 10.3994L11.3137 1.70691L14.8492 5.24244L6.15677 13.9349L2.62124 13.9349L2.62124 10.3994Z",
    stroke: "current"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.0815,
    y1: 7.40385,
    x2: 9.54597,
    y2: 3.86831,
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditV2);
export default __webpack_public_path__ + "static/media/editV2.bc671a97d6f5898f80857b2e79bdd2a0.svg";
export { ForwardRef as ReactComponent };